import { createSlice } from "@reduxjs/toolkit"
import { uploadingUserDetails, updateUserDetails } from "./userDetailsAction"
import { fetchUserDetails } from "./auth/authAction"

const initialState = {
  loading: false,
  detailsSuccess: false,
  data: [],
  usersImages: [],
  userToken: '',
  error: '',
  cacheTimestamp: null // Track when user list was fetched
}

const userDetailsSlice = createSlice({
  name: 'details',
  initialState,
  reducers: {
    setImage: (state, { payload }) => {
      state.usersImages = payload;
    },
    resetUserDetails: (state) => {
      state.usersImages = [];
      state.detailsSuccess = false;
      state.error = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadingUserDetails.pending, (state) => {
        state.loading = true;
        state.detailsSuccess = false;
      })
      .addCase(uploadingUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.detailsSuccess = true;
        state.data = action.payload;
      })
      .addCase(uploadingUserDetails.rejected, (state, action) => {
        state.detailsSuccess = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchUserDetails.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // Store fetched users in 'data'
        state.cacheTimestamp = Date.now(); // Set cache timestamp
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateUserDetails.pending, (state) => {
        state.loading = true;
        state.detailsSuccess = false;
        state.error = '';
      })
      .addCase(updateUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.detailsSuccess = true;
        // Optionally update state.data if needed, but navigation is the main goal
      })
      .addCase(updateUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.detailsSuccess = false;
        state.error = action.payload;
      })
      .addCase('auth/logout', (state) => {
        state.data = [];
        state.usersImages = {};
        state.detailsSuccess = false;
        state.cacheTimestamp = null;
        state.error = '';
      });
  }
})
export const { setImage, resetUserDetails } = userDetailsSlice.actions;
export default userDetailsSlice.reducer
